import * as Zod from 'zod';

export const employeeScheme = Zod.object({
  id: Zod.number(),
  label: Zod.string(),
});
